import React from 'react';

const Terms: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
      <h1 className="text-3xl font-bold text-domired-600 mb-6">Términos y Condiciones</h1>
      
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold mb-2">Aceptación de los Términos</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Al acceder o utilizar DomiRed, aceptas estar sujeto a estos Términos y Condiciones. 
            Si no estás de acuerdo con alguno de estos términos, te pedimos que no utilices 
            nuestra plataforma.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Uso de la Plataforma</h2>
          <p className="text-gray-700 dark:text-gray-300">
            DomiRed es una plataforma diseñada para la interacción social. Te comprometes 
            a utilizar la plataforma de manera responsable y a no publicar contenido ilegal, 
            ofensivo, difamatorio o que viole los derechos de terceros.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Propiedad Intelectual</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Todo el contenido publicado en DomiRed, incluyendo textos, gráficos, logotipos, 
            iconos y software, es propiedad de DomiRed o de sus respectivos propietarios. 
            El contenido generado por los usuarios pertenece a los usuarios que lo publican, 
            pero nos otorgan una licencia para mostrarlo en nuestra plataforma.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Limitación de Responsabilidad</h2>
          <p className="text-gray-700 dark:text-gray-300">
            DomiRed no se hace responsable de los daños directos, indirectos, incidentales, 
            consecuentes o punitivos que puedan surgir del uso o la imposibilidad de usar 
            nuestra plataforma. Utilizas la plataforma bajo tu propio riesgo.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Modificaciones a los Términos</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Nos reservamos el derecho de modificar estos términos en cualquier momento. 
            Las modificaciones entrarán en vigor inmediatamente después de su publicación. 
            El uso continuado de la plataforma después de cualquier cambio constituye tu 
            aceptación de los nuevos términos.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold mb-2">Ley Aplicable</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Estos términos se rigen por las leyes de la República Dominicana. Cualquier 
            disputa relacionada con estos términos será resuelta por los tribunales 
            competentes de la República Dominicana.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
